import Backbone from 'backbone';

import HeaderBarView from '@/views/HeaderBarView';

const CommandHeaderView = HeaderBarView.extend({
  className: 'command-header-view header-bar-view clearfix',

  initialize() {
    const columns = [
      {
        name: 'commandName',
        label: 'Command Name'
      },
      {
        name: 'dodac',
        label: 'DODAAC'
      },
      {
        name: 'id',
        label: 'Command ID'
      },
      {
        name: 'regionName',
        label: 'Location'
      }
    ];
    this.options.columns = new Backbone.Collection(columns);
  }
});

export default CommandHeaderView;
